<!-- ::START::LICENCE::
Copyright eQualityTime ©2018, ©2019, ©2020, ©2021, ©2022, ©2023, ©2024, ©2025
This file is part of OVFPlayer.
OVFPlayer is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.
OVFPlayer is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.
You should have received a copy of the GNU General Public License
along with OVFPlayer.  If not, see <https://www.gnu.org/licenses/>.
::END::LICENCE:: -->
<app-obfpage>
  <mat-card appearance="outlined" class="formCard">
    <div class="formTitle">
      Configuration
    </div>
    <form (ngSubmit)="save()" #configForm="ngForm">

      <div class="formButtons">
        <button type="submit" mat-raised-button color="primary" [disabled]="!configForm.form.valid">Save</button>
        <button type="button" mat-raised-button color="primary" (click)="exitConfig()">Cancel</button>
      </div>
      <mat-tab-group>
        <mat-tab ngModelGroup="boardURL" #boardURLCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (boardURLCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="boardURLCtrl.invalid" name="boardURL">Board URL</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <mat-form-field class="formInputField">
                <input [(ngModel)]="boardURL" required matInput name="boardURL" placeholder="URL for obf/obz file"
                  class="formInputUrl">
              </mat-form-field>
              <div class="clickable" (click)="copyToClipboard()"><i class="material-icons">link</i>&nbsp;Create link
              </div>
              <div class="clickable" (click)="refreshBoard()"><i class="material-icons">refresh</i>&nbsp;Reload board
                without changes</div>
              <div>
                <button id="useCK20" mat-raised-button type="button" (click)="resetToCK20()">Use default CK20
                  board</button>
                <button id="useCK12" mat-raised-button type="button" (click)="resetToCK12()">Use default CK12
                  board</button>
              </div>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab ngModelGroup="speechbarBehaviour" #speechbarBehaviourCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (speechbarBehaviourCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="speechbarBehaviourCtrl.invalid" name="speechbarBehaviour">Speechbar
              behaviour</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="speakOnSpeechbarClick" name="speakOnSpeechbarClick">
                <span class="formLabel">Speak when speechbar is clicked</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="showIconsInSpeechbar" name="showIconsInSpeechbar">
                <span class="formLabel">Display button images and labels in speechbar (instead of vocalisation
                  text)</span>
              </mat-checkbox>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab ngModelGroup="buttonBehaviour" #buttonBehaviourCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (buttonBehaviourCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="buttonBehaviourCtrl.invalid" name="buttonBehaviour">Button press behaviour</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="buttonBehaviourConfig.speakOnTrigger"
                name="buttonBehaviourConfig.speakOnTrigger">
                <span class="formLabel">Speak when button is pressed (as well as adding to speechbar)</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-radio-group [(ngModel)]="buttonBehaviourConfig.triggerEvent"
                name="buttonBehaviourConfig.triggerEvent">
                <div class="formLabel">Event to use to trigger button usage</div>
                <mat-radio-button [value]="interactionEventType.click">Full click</mat-radio-button>
                <mat-radio-button [value]="interactionEventType.mouseup">Release</mat-radio-button>
                <mat-radio-button [value]="interactionEventType.mousedown">Press</mat-radio-button>
              </mat-radio-group>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab ngModelGroup="displayedButtons" #displayedButtonsCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (displayedButtonsCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="displayedButtonsCtrl.invalid" name="displayedButtons">Permanent buttons</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="displayedButtons.showSpeakButton" name="showSpeakButton">
                <span class="formLabel">Speak button always shown</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="displayedButtons.showBackspaceButton" name="showBackspaceButton">
                <span class="formLabel">Backspace button always shown</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="displayedButtons.showClearButton" name="showClearButton">
                <span class="formLabel">Clear button always shown</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="displayedButtons.showHomeButton" name="showHomeButton">
                <span class="formLabel">Home button always shown</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="displayedButtons.showBackButton" name="showBackButton">
                <span class="formLabel">Back button always shown</span>
              </mat-checkbox>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab ngModelGroup="voiceConfig" #voiceConfigCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (voiceConfigCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="voiceConfigCtrl.invalid" name="voiceConfig">Voice Settings</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <mat-form-field class="formInputSelection">
                <mat-select [(ngModel)]="voiceConfig.userVoice" name="userVoice" placeholder="User Voice">
                  <mat-option>Use default</mat-option>
                  @for (voice of availableVoices(); track voice) {
                  <mat-option [value]="voice.voiceURI">
                    {{voice.name + " (" + voice.lang +")"}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab ngModelGroup="scanning" #scanningCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (scanningCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="scanningCtrl.invalid" name="scanning">Scanning</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="scanningConfig.enabled" name="scanningEnabled">
                <span class="formLabel">Enable scanning</span>
              </mat-checkbox>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-form-field class="formInputField">
                <input [required]="scanningConfig.enabled" type="number" [(ngModel)]="scanningConfig.time"
                  name="scanningTime" matInput placeholder="Time to stay on each scanned item (in milliseconds)">
              </mat-form-field>
            </mat-card>
          </div>
        </mat-tab>
        <mat-tab ngModelGroup="appearance" #appearanceCtrl="ngModelGroup">
          <ng-template mat-tab-label>
            @if (appearanceCtrl.invalid) {
            <mat-icon class="invalidTab">error</mat-icon>
            }
            <span [class.invalidTab]="appearanceCtrl.invalid" name="appearance">Appearance</span>
          </ng-template>
          <div class="formContainer">
            <mat-card appearance="outlined">
              <div>
                <mat-slider min="1" max="10" step="1" color="Primary" thumbLabel="true" #ngSlider><input matSliderThumb
                    [(ngModel)]="appearanceConfig.borderThickness" name="borderThickness"
                    #ngSliderThumb="matSliderThumb" /></mat-slider>
                <div class="borderExample" [style.border-width]="appearanceConfig.borderThickness + 'px'">Border
                  Thickness</div>
              </div>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-checkbox [(ngModel)]="appearanceConfig.highContrastText" name="highContrastText">
                <span class="formLabel">High contrast text</span>
              </mat-checkbox>
            </mat-card>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </mat-card>
  <p>Version: {{getVersion()}}</p>
</app-obfpage>